@for (field of field.fieldGroup; track field; let i = $index) {
  <div class="row">
    <formly-field class="col" [field]="field">
    </formly-field>
    @if (i != 0) {
      <div style="margin:30px 0;">
        <button mat-raised-button color="warn" type="button" (click)="remove(i)">{{ to.labelDileu }}</button>
      </div>
    }
  </div>
}
<div style="margin:30px 0;">
  <button mat-raised-button color="primary" type="button" (click)="add()">{{ to.labelYchwanegu }}</button>
</div>